import { render, staticRenderFns } from "./SampleModalActivity.vue?vue&type=template&id=d2a52c12&scoped=true&"
import script from "./SampleModalActivity.vue?vue&type=script&lang=js&"
export * from "./SampleModalActivity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a52c12",
  null
  
)

export default component.exports